import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL, pageSlug } from "../../../../Constants/AppConstants";
import { getPageWithSlugAPI } from "../../../../Store/Action/page";

import "./AboutUs.css";
import CustomImageComponent from "../../CustomComponents/CustomImageComponent";
import { useMediaQuery } from "@mui/material";
import HeaderBlack from "../Common/Header";
import { useLocation } from "react-router-dom";
import Header from "../../Layout/Header/Header";
import CustomLoader from "../../CustomComponents/CustomLoader/CustomLoader";
import Footer from "../../Layout/Footer/Footer";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";
import { getActiveSubscriptionAPI } from "../../../../Store/Action/subscriptionAction";
import { Helmet } from "react-helmet-async";

const AboutUs = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const fromAboutUsByLoggedInUser =
    location.state?.fromAboutUsByLoggedInUser || false;

  const [pageData, setPageData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userOnboardingStatus, setUserOnboardingStatus] = useState("");
  const is1660Screen = useMediaQuery("(max-width:1600px)");
  const is1024Screen = useMediaQuery("(max-width:1024px)");
  const is768Screen = useMediaQuery("(max-width:768px)");
  const is425Screen = useMediaQuery("(max-width:425px)");
  const imageHeight = is425Screen
    ? "200px"
    : is768Screen
    ? "300px"
    : is1024Screen
    ? "400px"
    : is1660Screen
    ? "500px"
    : "555px";
  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getPageWithSlugAPI(pageSlug.aboutUs, (result) => {
        setPageData(result);
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  const { isLoggedIn } = useSelector((state) => state.authSlice);

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {

        if (result?.status) {
          setUserOnboardingStatus(result?.data?.[0]?.user_status_name);
        }
      })
    );
  }, [dispatch, isLoggedIn]);

  const [hasSubscription, setHasSubscription] = useState(false);

  useEffect(() => {
    dispatch(
      getActiveSubscriptionAPI({}, (result) => {
        setHasSubscription(result?.length > 0);
        // setIsLoading(false);
      })
    );
  }, []);

  return (
    <>
      <Helmet>
        <title>About Us | Zabali</title>
        <meta
          name="description"
          content="Learn more about Zabali, connecting jewelry manufacturers and retailers with seamless wholesale buying."
        />
        <link rel="canonical" href="https://www.zabali.co/about-us" />
      </Helmet>

      <div className="about-us-main-div" style={{ minHeight: "64.6vh" }}>
        <div className="section-1-div" style={{ position: "sticky", top: 0 }}>
          {/* {isLoggedIn && userOnboardingStatus === "approved" ? (
            <Header />
          ) : (
            <HeaderBlack />
          )} */}
          {fromAboutUsByLoggedInUser ? (
            <>
              <Header />
            </>
          ) : (
            <>
              <HeaderBlack />
            </>
          )}
        </div>

        {isLoading ? (
          <div className="loaderContainer">
            <CustomLoader />
          </div>
        ) : pageData?.length > 0 ? (
          pageData?.map((e) => {
            return (
              <div className="about-us-div-container">
                <div className="about-us-img-div">
                  {/* <img
                  src={`${BASE_URL}${e?.page_og_image[0]?.page_about_us_image}`}
                  alt=""
                  style={{ objectFit: "contain" }}
                /> */}
                  <CustomImageComponent
                    src={`${BASE_URL}${e?.page_json?.[0]?.banner_image_id}`}
                    width={"100%"}
                    // height={"555px"}
                    height={imageHeight}
                  />
                </div>

                <div className="about-us-containt-div">
                  <p className="about-us-heading-para">
                    Connect With Zabali For Seamless Flow of Jewelry Purchase
                  </p>
                  {e?.page_json?.map((ee, index) => (
                    <p key={index} className="about-us-para">
                      {ee?.page_content_text}
                    </p>
                  ))}

                  {/* {e?.page_json?.map((eee, index) => (
                    <div key={index}>
                      {eee?.page_cards?.map((eeee, idx) => (
                        <p key={idx} className="about-us-para">
                          {eeee.card_title}
                        </p>
                      ))}
                    </div>
                  ))} */}
                </div>

                <div className="about-us-cards-div">
                  {e?.page_json?.map((jsonItem, index) =>
                    jsonItem.page_cards?.map((text, idx) => (
                      <div className="about-us-card" key={`${index}-${idx}`}>
                        <p>{text?.card_title}</p>
                      </div>
                    )),
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <>
            <p>No data available</p>
          </>
        )}
        {!isLoading && <Footer />}
      </div>
    </>
  );
};

export default AboutUs;
